import { render, staticRenderFns } from "./Retreat.vue?vue&type=template&id=54c7cf7a&scoped=true&"
import script from "./Retreat.vue?vue&type=script&lang=js&"
export * from "./Retreat.vue?vue&type=script&lang=js&"
import style0 from "./Retreat.vue?vue&type=style&index=0&id=54c7cf7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7cf7a",
  null
  
)

export default component.exports